"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Reports/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);








var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _phone = require('shared/services/phone');
var _common = require('shared/selectors/org/common');
var _hooks = require('web/services/hooks');
var _download = require('web/screens/Broadcast/Wizard/Recipients/download');

var _DataTable = require('web/components/DataTable'); var _DataTable2 = _interopRequireDefault(_DataTable);

var _Form = require('web/components/Form');
var _Tooltip = require('web/components/Tooltip');
var _range = require('./range');
var _RangePicker = require('./components/RangePicker'); var _RangePicker2 = _interopRequireDefault(_RangePicker);
var _Cards = require('./components/Cards'); var _Cards2 = _interopRequireDefault(_Cards);
var _DaysChart = require('./components/DaysChart'); var _DaysChart2 = _interopRequireDefault(_DaysChart);
var _PatientPanel = require('./components/PatientPanel'); var _PatientPanel2 = _interopRequireDefault(_PatientPanel);

const REPORTS_HELP_URL = 'https://www.bloomtext.com/how-to/admin/message-reports/'








// SimpleSelect hides an option whose value is '', so "all" stands for it.
const ALL = 'all'
const STATUS_PILLS = [
  { value: '', label: 'All' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'failed', label: 'Failed' },
  { value: 'not_sent', label: 'Not sent' },
  { value: 'waiting', label: 'Waiting' },
]
const TYPE_OPTIONS = [
  { value: 'patient_sms_conv', label: 'Staff text' },
  { value: 'patient_secure_conv', label: 'Secure link' },
  { value: 'patient_secure_conv_renewal', label: 'Secure link renewal' },
  { value: 'patient_auto_reply', label: 'Auto reply' },
  { value: 'patient_busy_reply', label: 'Busy reply' },
  { value: 'patient_keyword_reply', label: 'Keyword reply' },
  { value: 'patient_consent_request', label: 'Consent request' },
  { value: 'patient_consent_confirmation', label: 'Consent confirmation' },
]
const INITIAL_SORT = { sort: 'time' , desc: true }
const INITIAL_FILTERS = {}
const rowKey = (r) => r.ID

// The server's own wording for a refusal it explains, like the export cap.
const refusalOf = (e) => {
  const { Status, Error } = (_nullishCoalesce(e, () => ( {}))) 
  return Status === 'client_error' && typeof Error === 'string' ? Error : null
}

const TwoLines = ({ top, bottom }) => (
  _react2.default.createElement('div', { className: "settings--org-reports--cell", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  top )
    ,  bottom && _react2.default.createElement('span', { className: "settings--org-reports--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  bottom ) 
  )
)

// A short status; why it didn't arrive and what to do shows on hover or
// keyboard focus (RP-2), and screen readers hear it with the status.
const StatusCell = ({ row }) => {
  const className = `settings--org-reports--status settings--org-reports--status--${row.StatusKind}`
  if (!row.Reason) return _react2.default.createElement('span', { className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}},  row.Status )
  return (
    _react2.default.createElement(_Tooltip.HoverTooltip, {
      type: "dark",
      place: "top",
      showOnFocus: true,
      className: "settings--org-reports--status-tip",
      content: _react2.default.createElement('span', { className: "settings--org-reports--reason-tip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}},  row.Reason ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}

      , _react2.default.createElement('span', { className: `${className} settings--org-reports--status--explained`, tabIndex: 0, 'aria-label': `${row.Status}. ${row.Reason}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
        ,  row.Status 
      )
    )
  )
}

// Where the text came from (RP-6), with the API key or campaign under it.
const SourceCell = ({ row }) => (
  row.SourceKind === 'not_recorded'
    ? _react2.default.createElement('span', { className: "settings--org-reports--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, "Not recorded" )
    : _react2.default.createElement(TwoLines, { top: row.Source, bottom: row.SourceName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}} )
)







/* Account → Reports (master D-71, D-87): every text the account's orgs sent
 * to patients, with cards, texts per day and a log. Over several orgs the
 * range is at most 30 days (E-43); picking one org allows 90. */
const Reports = ({ orgKey, account }) => {
  const [filterOrg, setFilterOrg] = _react.useState('')
  const [team, setTeam] = _react.useState.call(void 0, '')
  const [range, setRange] = _react.useState(null) // null: the server's default
  const [limits, setLimits] = _react.useState(null)
  // The filter whose summary failed; the toolbar and log stay usable, so the
  // admin can pick a shorter range or one organization.
  const [failedFilter, setFailedFilter] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  // The patient whose panel is open (RP-4).
  const [openPatient, setOpenPatient] = _react.useState(null)
  const onClosePatient = _react.useCallback.call(void 0, () => setOpenPatient(null), [])

  const isOneOrg = !!filterOrg || account.OrgKeys.length === 1
  const scopeLimits = _react.useMemo.call(void 0, 
    () => limits && {
      DefaultRangeDays: limits.DefaultRangeDays,
      MaxRangeDays: isOneOrg ? limits.OrgMaxRangeDays : limits.AccountMaxRangeDays,
    },
    [limits, isOneOrg],
  )
  const defaultDays = _nullishCoalesce(_optionalChain([limits, 'optionalAccess', _ => _.DefaultRangeDays]), () => ( _range.INITIAL_RANGE_DAYS))
  const choice = _react.useMemo.call(void 0, () => _nullishCoalesce(range, () => ( { days: defaultDays })), [range, defaultDays])
  // The interval is fixed when the range is picked, so texts sent while the
  // admin pages through the log don't shift its pages.
  const filter = _react.useMemo(
    () => ({
      OrgKey: orgKey,
      ...(filterOrg && { FilterOrgKey: filterOrg }),
      ..._range.toInterval.call(void 0, choice),
      TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Team: team,
    }),
    [orgKey, filterOrg, choice, team],
  )

  // Each response is kept with the request it answers, so a slow reply to
  // an older filter never shows as the current one.
  const [summary, setSummary] = _react.useState(null)
  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      _client2.default.send('GetMessageReportSummary', filter)
        .then(data => {
          if (!isCurrent) return
          setSummary({ filter, data })
          setLimits(data.Limits)
        })
        .catch(() => { if (isCurrent) setFailedFilter(filter) })
      return () => { isCurrent = false }
    },
    [filter, attempt],
  )
  const hasSummaryFailed = failedFilter === filter

  // The first page counts the filter's texts; later pages send that total
  // back so the server doesn't count the range again.
  const known = _react.useRef(null)
  const [isSearchTooBroad, setIsSearchTooBroad] = _react.useState.call(void 0, false)
  const fetch = _react.useCallback.call(void 0, 
    (r) => {
      const key = JSON.stringify([filter, r.query, r.filters])
      const total = r.offset > 0 && _optionalChain([known, 'access', _2 => _2.current, 'optionalAccess', _3 => _3.key]) === key ? known.current.total : undefined
      return _client2.default.send('GetMessageReportPage', {
        ...filter,
        Query: r.query || undefined,
        Status: r.filters.status,
        Type: r.filters.type,
        Sort: r.sort,
        Desc: r.desc,
        Offset: r.offset,
        Limit: r.limit,
        ...(total !== undefined && { Total: total }),
      }).then(res => {
        if (r.offset === 0) known.current = { key, total: res.Total }
        setIsSearchTooBroad(!!res.TooManyPatients)
        return { rows: res.Rows, total: res.Total }
      })
    },
    [filter],
  )
  const table = _DataTable.useDataTable.call(void 0, {
    fetch, initialSort: INITIAL_SORT, initialFilters: INITIAL_FILTERS, pageSize: _optionalChain([limits, 'optionalAccess', _4 => _4.PageSize]),
  })
  const { filters, setFilters, reload } = table

  const onOrg = _react.useCallback.call(void 0, 
    (v) => {
      const next = v === ALL ? '' : v 
      setFilterOrg(next)
      setTeam('')
      // Leaving a one-org drill-down for the account view caps the range again.
      const accountMax = _optionalChain([limits, 'optionalAccess', _5 => _5.AccountMaxRangeDays])
      if (!next && accountMax && account.OrgKeys.length > 1) {
        const days = 'days' in choice ? choice.days : _range.countDays.call(void 0, choice.start, choice.end)
        if (days > accountMax) setRange(null)
      }
    },
    [limits, account.OrgKeys.length, choice],
  )
  const onTeam = _react.useCallback.call(void 0, (v) => setTeam(v === ALL ? '' : v), [])
  const onStatus = _react.useCallback.call(void 0, 
    (status) => setFilters({ ...filters, status: status || undefined }),
    [filters, setFilters],
  )
  const onShowFailed = _react.useCallback.call(void 0, () => onStatus('failed'), [onStatus])
  const onRetry = _react.useCallback.call(void 0, 
    () => {
      setFailedFilter(null)
      setAttempt(n => n + 1)
      reload()
    },
    [reload],
  )

  const [isExporting, setIsExporting] = _react.useState.call(void 0, false)
  const [exportError, setExportError] = _react.useState(null)
  const onExport = _react.useCallback.call(void 0, 
    () => {
      setIsExporting(true)
      setExportError(null)
      _client2.default.send('ExportMessageReport', {
        ...filter,
        Query: table.query || undefined,
        Status: filters.status,
        Type: filters.type,
        Sort: table.sort.sort,
        Desc: table.sort.desc,
      })
        .then(({ FileName, Csv }) => _download.downloadText.call(void 0, FileName, Csv, 'text/csv'))
        .catch(e => setExportError(_nullishCoalesce(refusalOf(e), () => ( "The export didn't finish. Try again."))))
        .finally(() => setIsExporting(false))
    },
    [filter, table.query, table.sort, filters],
  )

  // The summary names the orgs; until one loads (or when it fails) the
  // account's orgs come from the store, so a drill-down is still possible.
  const storeOrgs = _hooks.useAppSelector.call(void 0, _common.selectOrgs)
  const orgs = _react.useMemo.call(void 0, 
    () => _nullishCoalesce(_optionalChain([summary, 'optionalAccess', _6 => _6.data, 'access', _7 => _7.Orgs]), () => ( account.OrgKeys.map(k => ({ OrgKey: k, Name: _nullishCoalesce(_optionalChain([storeOrgs, 'access', _8 => _8[k], 'optionalAccess', _9 => _9.Name]), () => ( 'Organization')) })))),
    [summary, account.OrgKeys, storeOrgs],
  )
  const orgName = _react.useCallback.call(void 0, (k) => _nullishCoalesce(_optionalChain([orgs, 'access', _10 => _10.find, 'call', _11 => _11(o => o.OrgKey === k), 'optionalAccess', _12 => _12.Name]), () => ( '')), [orgs])
  const showOrgs = account.OrgKeys.length > 1
  const orgOptions = _react.useMemo.call(void 0, 
    () => [{ value: ALL, label: 'All organizations' }, ...orgs.map(o => ({ value: o.OrgKey, label: o.Name }))],
    [orgs],
  )
  const teams = _optionalChain([summary, 'optionalAccess', _13 => _13.data, 'access', _14 => _14.Teams])
  const teamOptions = _react.useMemo.call(void 0, 
    () => [
      { value: ALL, label: 'All teams' },
      ...(_nullishCoalesce(teams, () => ( []))).map(t => ({
        value: t.Team,
        label: `${t.Name}${showOrgs && !filterOrg && t.OrgKey ? ` (${orgName(t.OrgKey)})` : ''} · ${_phone.formatPhoneNumber.call(void 0, t.Number)}`,
      })),
    ],
    [teams, showOrgs, filterOrg, orgName],
  )

  const columns = _react.useMemo.call(void 0, () => [
    {
      id: 'time',
      label: 'Date and time',
      sort: 'time',
      // RP-8: fits the widest value on one line ("Sep 30, 12:59 PM" is 108px
      // at the table's 14px, plus 28px padding), with room to spare.
      width: 145,
      cell: r => _react2.default.createElement('span', { className: "settings--org-reports--nowrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}},  _moment2.default.call(void 0, r.SentAt).format('MMM D, h:mm A') ),
    },
    ...(showOrgs
      ? [{ id: 'org', label: 'Organization', sort: 'organization' , width: 115, cell: (r) => r.Org.Name }]
      : []),
    {
      id: 'team',
      label: 'Team',
      sort: 'team',
      width: 135,
      cell: r => r.Team
        ? _react2.default.createElement(TwoLines, { top: r.Team.Name, bottom: _phone.formatPhoneNumber.call(void 0, r.Team.Number), __self: this, __source: {fileName: _jsxFileName, lineNumber: 289}} )
        : _react2.default.createElement('span', { className: "settings--org-reports--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}, "Not recorded" ),
    },
    {
      id: 'to',
      label: 'To',
      width: 150,
      // The name opens the patient's panel, as in the Directory's table; a
      // second click on the open patient closes it.
      cell: r => (
        _react2.default.createElement(TwoLines, {
          top: (
            _react2.default.createElement('button', {
              type: "button",
              className: `settings--org-reports--link ${_PatientPanel.PATIENT_LINK_CLASS}`,
              onClick: () => setOpenPatient(p => _optionalChain([p, 'optionalAccess', _15 => _15.patientKey]) === r.PatientKey ? null : { orgKey: r.Org.OrgKey, patientKey: r.PatientKey }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}

              ,  r.PatientName || 'Unknown patient' 
            )
          ),
          bottom: _phone.formatPhoneNumber.call(void 0, r.ToNumber), __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}}
        )
      ),
    },
    {
      id: 'sentBy',
      label: 'Sent by',
      width: 130,
      cell: r => r.SentBy || _react2.default.createElement('span', { className: "settings--org-reports--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 317}}, "—"),
    },
    { id: 'source', label: 'Source', width: 120, cell: r => _react2.default.createElement(SourceCell, { row: r, __self: this, __source: {fileName: _jsxFileName, lineNumber: 319}} ) },
    { id: 'type', label: 'Type', sort: 'type', width: 120, cell: r => r.Type },
    { id: 'status', label: 'Status', sort: 'status', cell: r => _react2.default.createElement(StatusCell, { row: r, __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}} ) },
  ], [showOrgs])

  const statusPills = (
    _react2.default.createElement('div', { className: "settings--org-reports--pills", role: "group", 'aria-label': "Status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}
      ,  STATUS_PILLS.map(p => (
        _react2.default.createElement('button', {
          key: p.value || ALL,
          type: "button",
          'aria-pressed': (_nullishCoalesce(filters.status, () => ( ''))) === p.value,
          className: _classBuilder2.default.call(void 0, 'settings--org-reports--pill', (_nullishCoalesce(filters.status, () => ( ''))) === p.value && 'settings--org-reports--pill--on'),
          onClick: () => onStatus(p.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}

          ,  p.label 
        )
      ))
    )
  )
  const typeFilter = (
    _react2.default.createElement(_DataTable.DataTableFilterGroup, {
      label: "Type",
      options: TYPE_OPTIONS,
      value: filters.type,
      onChange: type => setFilters({ ...filters, type }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 340}}
    )
  )
  const totalTexts = _nullishCoalesce(_optionalChain([summary, 'optionalAccess', _16 => _16.data, 'access', _17 => _17.Days, 'access', _18 => _18.reduce, 'call', _19 => _19((n, d) => n + d.Texts, 0)]), () => ( 0))
  const isFiltered = !!table.query || !!filters.status || !!filters.type

  return (
    _react2.default.createElement('div', { className: "settings--org-reports", __self: this, __source: {fileName: _jsxFileName, lineNumber: 351}}
      , _react2.default.createElement('div', { className: "settings--org-reports--toolbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}}
        ,  showOrgs && (
          _react2.default.createElement(_Form.SimpleSelect, {
            'aria-label': "Organization",
            className: "settings--org-reports--select",
            value: filterOrg || ALL,
            options: orgOptions,
            onChange: onOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 354}}
          )
        )
        ,  teams && teams.length > 1 && (
          _react2.default.createElement(_Form.SimpleSelect, {
            'aria-label': "Team",
            className: "settings--org-reports--select",
            value: team || ALL,
            options: teamOptions,
            onChange: onTeam, __self: this, __source: {fileName: _jsxFileName, lineNumber: 363}}
          )
        )
        /* A range reset from outside (leaving a drill-down) starts the picker over. */
        , _react2.default.createElement(_RangePicker2.default, { key: range ? 'picked' : 'default', choice: choice, limits: scopeLimits, onChange: setRange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 372}} )
        , _react2.default.createElement(_Form.Button, {
          isOutlined: true,
          isLoading: isExporting,
          className: "settings--org-reports--export",
          onClick: onExport, __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}}
, "Export CSV"

        )
      )
      , _react2.default.createElement('p', { className: "settings--org-reports--live", __self: this, __source: {fileName: _jsxFileName, lineNumber: 382}}, "Live. Each status updates as the carrier reports back."        )
      ,  exportError && (
        _react2.default.createElement('p', { className: "settings--org-reports--export-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 384}},  exportError )
      )
      ,  hasSummaryFailed && (
        _react2.default.createElement('div', { className: "settings--org-reports--failed", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 387}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 388}}, "Reports didn't load. Try again, or pick a shorter range or one organization."            )
          , _react2.default.createElement(_Form.Button, { onClick: onRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 389}}, "Try again" )
        )
      )
      ,  summary && !hasSummaryFailed && (
        _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, summary.filter !== filter && 'settings--org-reports--stale'), 'aria-busy': summary.filter !== filter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 393}}
          , _react2.default.createElement(_Cards2.default, { cards: summary.data.Cards, totalTexts: totalTexts, isTeamPicked: !!summary.filter.Team, onShowFailed: onShowFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 394}} )
          , _react2.default.createElement(_DaysChart2.default, { days: summary.data.Days, __self: this, __source: {fileName: _jsxFileName, lineNumber: 395}} )
        )
      )
      , _react2.default.createElement('section', { className: "settings--org-reports--log", 'aria-label': "Texts", __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}}
        , _react2.default.createElement('h3', { className: "settings--org-reports--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 399}}, "Texts")
        , _react2.default.createElement(_DataTable2.default, {
          label: "Texts",
          table: table,
          columns: columns,
          rowKey: rowKey,
          searchPlaceholder: "Search a patient or type a number"      ,
          filters: typeFilter,
          activeFilters: filters.type ? 1 : 0,
          toolbarExtra: statusPills,
          noun: ['text', 'texts'],
          emptyState: isSearchTooBroad
            ? 'More than 100 patients match. Type more of the name.'
            : isFiltered ? 'No texts match these filters.' : 'No texts in this range.', __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}}
        )
      )
      , _react2.default.createElement('p', { className: "settings--org-reports--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 415}}, "Only Owners and IT see Reports. Message text is never shown."
                  , ' '
        , _react2.default.createElement('a', { href: REPORTS_HELP_URL, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 417}}, "IT can read delivery status through the BloomText API."

        )
      )
      ,  openPatient && (
        _react2.default.createElement(_PatientPanel2.default, {
          key: openPatient.patientKey,
          orgKey: openPatient.orgKey,
          patientKey: openPatient.patientKey,
          onClose: onClosePatient, __self: this, __source: {fileName: _jsxFileName, lineNumber: 422}}
        )
      )
    )
  )
}

exports. default = Reports
